import { RegenerateMenuItems } from '@/components/session/RegenerateMenu';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Ellipsis, Eye, Loader2, Maximize2 } from 'lucide-react';
import type { NoteMoreMenuProps } from './noteInstructions.types';

/** "⋯": regenerate (with the RegenerateMenu styles), the large editor and the template editor. */
export const NoteMoreMenu = ({
  onRegenerate,
  regenerateDisabled,
  onExpand,
  onEditTemplate,
  isLoadingTemplate,
}: NoteMoreMenuProps) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button size="icon" variant="ghost" className="h-8 w-8 text-muted-foreground" aria-label="Fleiri aðgerðir">
        <Ellipsis className="h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-60">
      {onRegenerate && (
        <>
          <DropdownMenuLabel className="text-muted-foreground text-xs">Endurgera</DropdownMenuLabel>
          <RegenerateMenuItems onSelect={onRegenerate} disabled={regenerateDisabled} grouped />
          {(onExpand || onEditTemplate) && <DropdownMenuSeparator />}
        </>
      )}
      {onExpand && (
        <DropdownMenuItem onSelect={onExpand}>
          <Maximize2 className="h-4 w-4" />
          Opna í stórum glugga
        </DropdownMenuItem>
      )}
      {onEditTemplate && (
        <DropdownMenuItem disabled={isLoadingTemplate} onSelect={onEditTemplate}>
          {isLoadingTemplate ? <Loader2 className="h-4 w-4 animate-spin" /> : <Eye className="h-4 w-4" />}
          Skoða og breyta sniðmáti
        </DropdownMenuItem>
      )}
    </DropdownMenuContent>
  </DropdownMenu>
);
